<template>
  <div class="report-header">
    <div class="report-header-left">
      <div class="report-header-icon">
        <file-text-outlined />
      </div>
      <div class="report-header-text">
        <div class="report-header-title">开发者生态综合月报</div>
        <div class="report-header-subtitle">数据提取截止于 2026-07-27</div>
      </div>
    </div>
    <a-button type="primary" class="export-btn" @click="$emit('export')" :loading="loading">
      <template #icon>
        <download-outlined />
      </template>
      导出报告
    </a-button>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { FileTextOutlined, DownloadOutlined } from '@ant-design/icons-vue';

defineProps({
  loading: { type: Boolean, default: false }
});
defineEmits(['export']);
</script>

<style scoped>
.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.report-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.report-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #722ed1 0%, #531dab 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.report-header-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 4px;
  text-align: left;
}

.report-header-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  text-align: left;
}

.export-btn {
  background: linear-gradient(135deg, #722ed1 0%, #531dab 100%);
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(114, 46, 209, 0.3);
}

.export-btn:hover {
  background: linear-gradient(135deg, #9254de 0%, #722ed1 100%);
  box-shadow: 0 4px 12px rgba(114, 46, 209, 0.4);
}

.export-btn :deep(.ant-btn-icon) {
  display: inline-flex;
  align-items: center;
}
</style>
